export default __webpack_public_path__ + "static/SommierIcon-3df5cc8249eaf8769b3e0273ac7b6d08.jpg";